import React, { useEffect } from "react";
import { Banner, trackBannerClick, trackBannerView } from "../../../insfrastructure/services/banners";
import closeIcon from "../../../assets/icons/close.svg";
import "./styles.sass";

interface MarketingPopupProps {
  popup: Banner;
  isOpen: boolean;
  onClose: () => void;
}

export const MarketingPopup: React.FC<MarketingPopupProps> = ({
  popup,
  isOpen,
  onClose,
}) => {
  const [opened, setOpened] = React.useState(false);

  useEffect(() => {
    if (isOpen) {
      // Registrar visualização quando o popup abre
      trackBannerView(popup.id);

      // Animar abertura
      setTimeout(() => {
        setOpened(true);
      }, 10);
    } else {
      setOpened(false);
    }
  }, [isOpen, popup.id]);

  const handleImageClick = () => {
    // Registrar clique
    trackBannerClick(popup.id);

    // Se houver link, abrir em nova aba
    if (popup.link) {
      window.open(popup.link, "_blank", "noopener,noreferrer");
    }

    // Fechar popup
    onClose();
  };

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpened(false);
    setTimeout(() => {
      onClose();
    }, 300); // Aguardar animação de fechamento
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className={`marketing-popup-overlay ${opened ? "opened" : ""}`} onClick={handleClose}>
      <div className={`marketing-popup-container ${opened ? "opened" : ""}`} onClick={(e) => e.stopPropagation()}>
        <button className="marketing-popup-close" onClick={handleClose} aria-label="Fechar">
          <img src={closeIcon} alt="Fechar" />
        </button>

        <div 
          className="marketing-popup-image-wrapper" 
          onClick={handleImageClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleImageClick();
            }
          }}
        >
          <img 
            src={popup.image} 
            alt={popup.name || "Popup de marketing"} 
            className="marketing-popup-image"
          />
        </div>
      </div>
    </div>
  );
};

